import {Component, OnInit} from '@angular/core';
import {ProductInfo} from "../../../models/ProductInfo";
import {ProductService} from "../../../service/product.service";
import {OrdersService} from "../../../service/orders.service";
import {Order} from "../../../models/Order";
import {ActivatedRoute} from "@angular/router";
import {UserService} from "../../../service/user.service";
import {Item} from "../../../models/item";
import {OrderStatus} from "../../../enums/OrderStatus";
import {ShippingType} from "../../../enums/ShippingType";
import {SharedConstants} from "../../../utilityClass/sharedConstants";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-admin-order-detail',
  templateUrl: './admin-order-detail.component.html',
  styleUrl: './admin-order-detail.component.scss'
})
export class AdminOrderDetailComponent implements OnInit {
  products: ProductInfo[] = []
  order!: Order;

  constructor(protected productService: ProductService,
              private orderService: OrdersService,
              private route: ActivatedRoute,
              protected userService: UserService,
              private translateService: TranslateService,
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const orderId = params['id'];
      this.orderService.getOrderById(orderId).subscribe({
        next: order => {
          this.order = order;
          this.loadProductsMainPictures(order.shoppingCart.items)
        },
        error: error => {
          alert('Error fetching order:' + error.message)
        }
      })
    })
  }

  calculateSubtotal(): number {
    if (!this.order || !this.order.shoppingCart || !this.order.shoppingCart.items) {
      return 0;
    }
    return this.order.shoppingCart.items.reduce(
      (sum, item) => sum + item.product.price * item.quantity,
      0
    );
  }

  private loadProductsMainPictures(items: Item[]) {
    items.forEach(item => {
      const imageUrl = item.product.imageUrls.at(0);
      if (imageUrl) {
        this.productService.getPictureByName(imageUrl).subscribe({
          next: (fileResponse: Blob) => {
            item.product.mainImageSafeUrl = URL.createObjectURL(fileResponse);
          }
        })
      }
    });
  }

  getShippingMethodName(): string {
    if (!this.order?.shippingMethod?.type) {
      return '';
    }
    return this.order.shippingMethod.type;
  }

  getShippingChargeText(): string {
    if (!this.order?.shippingMethod?.type) {
      return '';
    }
    if (this.order.shippingMethod.type === ShippingType.STANDARD) {
      return SharedConstants.FREE;
    } else if (this.order.shippingMethod.type === ShippingType.PICKUP) {
      return SharedConstants.FREE;
    } else {
      return SharedConstants.PAY_TO_YANDEX;
    }
  }

  protected readonly OrderStatus = OrderStatus;
  protected readonly ShippingType = ShippingType;
  protected readonly SharedConstants = SharedConstants;
}
